document.addEventListener('DOMContentLoaded', function() {
  
  const monsterActive = !!document.querySelector('script[src*="/cart_renderer"]');
  
  if (!monsterActive) return;
  
  // Intercept fetch requests
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const [url, options] = args;
    
    if (url.includes('/cart/add.js') || url.includes('/cart/add')) {
      return originalFetch.apply(this, args)
        .then(response => {
          if (response.ok) {
            console.log('Add to cart successful (fetch) - refreshing cart');
            
            setTimeout(() => {
              if (typeof window.monster_refresh === 'function') {
                window.monster_refresh(true, function() {
                  if (typeof window.openCart === 'function') {
                    window.openCart();
                  }
                });
              }
            }, 100);
          }
          return response;
        });
    }
    
    return originalFetch.apply(this, args);
  };
  
});